import {faCircleNotch, faClone, faTrash} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, ButtonGroup, Row } from "react-bootstrap";

const InstanceTemplateActionCell = (props) => (
    <Row style={{ display: "block" }}>
      <div className="floatRight">
        <ButtonGroup size="sm">
          <Button
              className="btn-black"
              onClick={event => {
                event.stopPropagation();
                props.onClone();
              }}
              disabled={props.cloneItemId !== null}
          >
            {props.cloneItemId === props.item._id ?
                (<FontAwesomeIcon icon={faCircleNotch} size="1x" spin />)
                : (<FontAwesomeIcon icon={faClone} size="1x" />)}
          </Button>
          <Button
              className="btn-red"
              onClick={event => {
                event.stopPropagation();
                props.onDelete();
              }}
          >
            <FontAwesomeIcon icon={faTrash} size="1x" />
          </Button>
        </ButtonGroup>
      </div>
    </Row>
);

export default InstanceTemplateActionCell;
